export default __webpack_public_path__ + "static/media/flag.5cd1de14.svg";